<template>
  	<div class="animated fadeIn">
		<b-row>
		    <b-col cols="12">
				<b-card header-tag="header" footer-tag="footer">
			        <div slot="header">
						<i class="fa fa-align-justify"></i><strong> {{$trans['general']['informations']}}</strong><small v-if="!loading1"> - {{item1.name}}, {{item1.district.name}}</small>
			        </div>
			        <div>
						<b-row>
							<b-col lg="6">
								<b-row>
									<b-col md="12">
										<!-- <label for="choose-item">Escolher Concelho</label> -->
										<b-form-group :label="$trans[$route.meta.trans_key]['county']" label-for="sel-county">
											<b-form-select id="sel-county" v-model="id_item_selected">
												<option v-for="item in all_items" :key="item.id" :value="item.id">{{item.name}}, {{item.district.name}}</option>
											</b-form-select>
										</b-form-group> 
									</b-col>
									<b-col md="12">
										<b-form-group :label="$trans[$route.meta.trans_key]['search_county']" :label-for="search1.id">
     										<autosuggest v-bind:input="search1" v-bind:key_compare="'name'" v-bind:show="!loading1" v-bind:items="all_items" v-on:choose-item="choose_item_search1"></autosuggest>
										</b-form-group>
									</b-col>
								</b-row>
								<b-row>
									<b-col md="12">
										<b-tabs pills class="text-capitalize">
											<b-tab :title="$trans['general']['general']">
												<b-col md="12" :class="(!loading1) ? 'has_data' : ''" class="card-loader-container p-0">
													<loader v-if="loading1"></loader>
													<div v-else>
														<h4 class="text-center">{{item1.name}},<router-link :to="base_url+ '/div-admin/distritos/' +item1.district.id"> {{item1.district.name}}</router-link></h4>
														<b-list-group class="mobile-list">
															<b-list-group-item><b>{{$trans[$route.meta.trans_key]['resident_population']}} (<router-link :to="base_url+ '/demografia/concelhos/' +item1.id">{{$trans['general']['censuses']}} 2011</router-link>):</b> {{item1.population}}</b-list-group-item>
															<b-list-group-item><b>{{$trans[$route.meta.trans_key]['area']}}:</b> {{item1.area_km}} km<sup>2</sup></b-list-group-item>
															<b-list-group-item><b>{{$trans[$route.meta.trans_key]['population_density']}} (<router-link :to="base_url+ '/demografia/concelhos/' +item1.id">{{$trans['general']['censuses']}} 2011</router-link>):</b> {{item1.population_density}} hab/km<sup>2</sup></b-list-group-item>
															<b-list-group-item><b>{{$trans[$route.meta.trans_key]['iso_code']}}:</b> {{item1.cod_distrito_INE}}{{item1.cod_INE}}	</b-list-group-item>
															<b-list-group-item><b>{{$trans[$route.meta.trans_key]['iso_code_3']}}:</b> {{item1.cod_3}}</b-list-group-item>
															<b-list-group-item><b>Data/Ano de inauguração:</b> {{item1.inauguration}}</b-list-group-item>
															<b-list-group-item><b>Brasão: </b><br><br><img class="county-badge" :src="assets_url+ 'images/counties_badges/' +item1.badge"></b-list-group-item>
															<!-- <b-list-group-item v-for="(desc, key) in item1" :key="key"><b>{{key}}:</b> <span v-html="desc"></span></b-list-group-item> -->
														</b-list-group>
													</div>
												</b-col>
											</b-tab>
											<b-tab :title="$trans['general']['nav_fregs']+ ' (' +sec_items.length+ ')'" v-on:click="tab1_2_idx = 1">
												<b-col md="12" :class="(!loading2) ? 'has_data' : ''" class="card-loader-container p-0">
													<loader v-if="loading2"></loader>
													<b-list-group v-else class="mobile-list">
														<b-list-group-item class="cursor-pointer" v-on:click="open_sec_item_infowindow(item, maps_data2.map_data.map_ele)" v-for="(item, idx) in sec_items" :key="idx">
															<span class="d-inline-block align-middle w-75">
																<span v-html="item.name"></span>
																&nbsp;<span class="icon-action-redo"></span>
																&nbsp;<router-link :to="base_url+ '/div-admin/freguesias/concelho/' +item1.id+ '/freguesia/' +item.id">{{$trans[$route.meta.trans_key]['know_more']}}</router-link>
															</span>
															<span class="d-inline-block align-middle w-25 text-right">
																<img  v-if="item.badge !== null" class="list-badge" :src="assets_url+ 'images/fregs_badges/' +item.badge">
															</span>
														</b-list-group-item>
													</b-list-group>
												</b-col>
											</b-tab>
											<b-tab :title="$trans[$route.meta.trans_key]['meteorology']">
												<b-col md="12" :class="(!loading1) ? 'has_data' : ''" class="card-loader-container p-0">
													<loader v-if="loading1"></loader>
													<div v-else>
														
														<b-list-group class="mobile-list">
															<b-list-group-item>
																<img :src="assets_url+ 'images/weather_icons/' +item1.current_weather.weather_icon">
															</b-list-group-item>
															<b-list-group-item>
																<b>Descrição:</b> {{item1.current_weather.weather_description}}
															</b-list-group-item>
															<b-list-group-item>
																<b>Temperatura:</b> {{item1.current_weather.temp}} ºC
															</b-list-group-item>
															<b-list-group-item>
																<b>Temperatura mínima:</b> {{item1.current_weather.temp_min}} ºC
															</b-list-group-item>
															<b-list-group-item>
																<b>Temperatura máxima:</b> {{item1.current_weather.temp_max}} ºC
															</b-list-group-item>
															<b-list-group-item>
																<b>Nascer do Sol:</b> {{item1.current_weather.sunrise}}
															</b-list-group-item>
															<b-list-group-item>
																<b>Pôr do Sol:</b> {{item1.current_weather.sunset}}
															</b-list-group-item>
															<b-list-group-item>
																<b>Velocidade do vento:</b> {{item1.current_weather.wind_speed}} m/s
															</b-list-group-item>
															<b-list-group-item>
																<b>Direção do vento:</b> {{item1.current_weather.wind_deg}}º (meteorológicos)
															</b-list-group-item>
															<b-list-group-item>
																<b>Pressão atmosférica em terra:</b> {{item1.current_weather.grnd_level}} hPa
															</b-list-group-item>
															<b-list-group-item>
																<b>Pressão atmosférica em mar:</b> {{item1.current_weather.sea_level}} hPa
															</b-list-group-item>
															<b-list-group-item>
																<b>Último update:</b> {{item1.current_weather.data_updated}}
															</b-list-group-item>
														</b-list-group>
													</div>
												</b-col>
											</b-tab>
								        </b-tabs>
									</b-col>
								</b-row>
							</b-col>
							<b-col lg="6">
								<b-row>
									<b-col md="12">
										<b-form-group label="hidden-inp" class="invisible d-lg-block d-none">
											<b-form-select>
												<option></option>
											</b-form-select>
										</b-form-group>
										<div class="mt-lg-0 mt-4">
											<b-form-group :label="$trans[$route.meta.trans_key]['map_style']" label-for="sel-map-style">
												<b-form-select id="sel-map-style" v-model="map.style" text="Estilo do mapa" right>
													<option v-for="(item, idx) in map.styles" :key="idx" :value="item">{{item.name}}</option>
												</b-form-select>
											</b-form-group>
										</div>
									</b-col>
								</b-row>
								<b-row>
									<b-col md="12">
										<b-tabs class="text-capitalize" pills v-model="tab1_2_idx">
											<b-tab :title="$trans[$route.meta.trans_key]['county']">
												<div class="loader-wrapper text-transform-none">
													<loader v-if="loading1"></loader>
													<l-map-wrapper v-else v-bind:data="maps_data1" v-bind:mapStyle="map.style" v-on:setStyles="setMapStyles" :ref="maps_data1.map_data.map_ele" v-bind:mapType="'geojson'" class="my-map-leaflet"></l-map-wrapper>
												</div>
											</b-tab>
											<b-tab :title="'Freguesias (' +sec_items.length+ ')'">
												<div class="loader-wrapper text-transform-none">
													<loader v-if="loading2"></loader>
													<l-map-wrapper v-else-if="load_map2" v-bind:data="maps_data2" v-bind:mapStyle="map.style" v-on:setStyles="setMapStyles" :ref="maps_data2.map_data.map_ele" v-bind:mapType="'geojson'" class="my-map-leaflet"></l-map-wrapper>
												</div>
											</b-tab>
							        	</b-tabs>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
			        </div>
			    </b-card>
			</b-col>
		</b-row>
	</div>
</template>
<script>

import LMapWrapper from '@/views/sub_components/LMapWrapper';

export default {
	name: 'Admin_Counties',
	components: {
		LMapWrapper
	},
	data() {
		return {
			disclaimer_active: null,
			all_items: [],
			id_item_selected: this.$route.params.id,
			tab1_2_idx: 0,
			item_details: {},
			sec_items: [],
			search1: {
				id: 'search-county',
				value: '',
				has_error: false,
				placeholder: this.$trans[this.$route.meta.trans_key]['county'],
				error: this.$trans[this.$route.meta.trans_key]['county']+ ' não encontrado'
			},
			loading1: true,
			loading2: true,
			loading3: true,
			loading4: true,
			maps_data1: null,
			maps_data2: null,
			map: {style: null, styles: []},
			load_map2: false,
		}
	},
	methods: {
		get_map_data1: function() {
			const that = this;
			that.get_req('counties/geo_data/' +that.id_item_selected,
				function() { // before
					that.loading1 = true;
	            },
				function(response) { // success
					that.maps_data1 = response.body.data.map1;
					that.sec_items = response.body.data.sec_items;
					that.item_details = response.body.data.item_details;
					that.loading1 = false;
					if(that.search1.value != '') {
						that.search1.value = '';
						that.search1.has_error = false;
					}
				},
				function(response) { // fail
					alert('ajax main.js error: '+ response.status);
				},
				function(response) {
					// always
				}
			);
		},
		get_map_data2: function() {
			const that = this;
			that.get_req('counties/geo_data/' +that.id_item_selected+ '/freguesias',
				function() { // before
					that.loading2 = true;
	            },
				function(response) { // success
					that.maps_data2 = response.body.data.map2;
      				that.loading2 = false;
					// appending county geo at the first place, so we can see the stroke of the county behind
					/*if(that.maps_data1 !== null)
						that.maps_data2.map_data.geo_data.unshift(that.maps_data1.map_data.geo_data);*/
				},
				function(response) { // fail
					alert('ajax main.js error: '+ response.status);
				},
				function(response) {
					
				}
			);
		},
		init_comp: function() {
			if(this.globs['counties'] !== null) {
				this.all_items = this.globs['counties'];
				this.id_item_selected = this.get_starter_item(this.globs['counties'], this.id_item_selected).id;
				return;
			}
			const that = this;
			that.get_req('counties/all',
				function() { // before
					//that.loading = true;
	            },
				function(response) { // success
					that.all_items = response.body;
					that.globs['counties'] = that.all_items;
					that.id_item_selected = that.get_starter_item(that.all_items, that.id_item_selected).id; // trigger watch
				},
				function(response) { // fail
					alert('ajax main.js error: '+ response.status);
				},
				function(response) {
					
				});
		},
		do_search1: function() {
			if(this.search1.value.trim() !== '') {
				var item_selected_tmp = this.all_items.find((item, idx) => item.name == this.search1.value || item.name.toLowerCase() == this.search1.value.toLowerCase());
				if(typeof item_selected_tmp === 'undefined') {
					this.search1.has_error = true;
					return;
				}
				this.id_item_selected = item_selected_tmp.id;
				this.search1.has_error = false;
			}
		},
		open_sec_item_infowindow: function(item, ref) {
			this.$refs[ref].trigger_popup(item.id, ref);
		},
		setMapStyles: function(styles) {
			this.map.styles = styles;
			if(this.map.style === null)
				this.map.style = styles[0];
		},
	},
	watch: {
		id_item_selected: function(new_val, old_val) {
			if(typeof new_val === 'undefined') {
				this.init_comp();
			}
			else {
				this.get_map_data1();
				this.get_map_data2();
			}
		},
		'$route.params.id': function(new_val, old_val) {
			if(typeof new_val === 'undefined') { //back button porpuses
				this.$router.go(-1);
			}
			else if(this.id_item_selected != new_val) {
				this.id_item_selected = new_val;
			}
		},
		item_details: function(new_val, old_val) {
			this.$router.push({name: 'Admin_Counties', params: {lang: this.$lang, id: this.id_item_selected, slug: new_val.slug}});
			this.tab1_2_idx = 0;
			this.load_map2 = false;
		},
		tab1_2_idx: function(new_val, old_val) {
			if(new_val == 1 && !this.load_map2) {
				this.load_map2 = true;
			}
		},
	},
	computed: {
		item1: function() {
			if(!this.loading1) {
				this.item_details['population_density'] = ((this.item_details.population/this.item_details.area_km).toFixed(2));
			}
			return this.item_details;
		}
	},
	created: function() {
		this.init_comp();
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.county-badge {
	display: block;
	margin: 0 auto;
	width: 160px;
}
.list-badge {
	height: 30px;
}
/*.censos_chart {
  background: #212733;
  border-radius: 15px;
  box-shadow: 0px 2px 15px rgba(25, 25, 25, 0.27);
  
}

.censos_chart h2 {
  margin-top: 0;
  padding: 15px 0;
  color:  rgba(255, 0,0, 0.5);
  border-bottom: 1px solid #323d54;
}*/
</style>